<template>
    <div>
        <!-- PURCHASE CARD -->
        <div class="purchase-card">
            <template v-if="isOwned">
                <div class="pp-buy-owned-badge">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"/>
                    </svg>
                    You already own this
                </div>
                <a
                    class="pp-buy-btn pp-buy-btn--owned"
                    :href="ownedUrl || (accURL + '/dashboard')"
                >Open toolkit →</a>

                <div class="pp-buy-owned-hint">
                    Continue where you left off — your progress is saved.
                </div>
            </template>

            <template v-else>
                <div class="card-top">
                    <span class="sold-stat" v-if="buyBox.urgency_text" v-html="buyBox.urgency_text"></span>
                    <span class="rating" v-if="buyBox.rating">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#FBBF24" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
                        </svg>
                        {{ buyBox.rating }}
                        <span v-if="buyBox.rating_count">({{ buyBox.rating_count }})</span>
                    </span>
                </div>

                <div class="price-row">
                    <span class="price-now">{{ formatMoney( product.sale_price ) }}</span>
                    <span class="price-was" v-if="hasDiscount">{{ formatMoney( product.price ) }}</span>
                    <span class="save-badge" v-if="savePercent > 0">Save {{ savePercent }}%</span>
                </div>

                <p class="price-meta">{{ priceMeta }}</p>

                <!-- Balance row (только для pass-low веток) -->
                <div
                    v-if="isLow"
                    class="balance-row show is-low"
                >
                    <span class="balance-label">
                        <span class="balance-warning">!</span>
                        <span>Not enough credits</span>
                    </span>
                    <span class="balance-val low">
                        <span class="credit-coin">
                            <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 8L9.5 6.5L19.5 4L21 8L24 9V22.5L4.5 23L3.5 19.5V8Z" fill="currentColor" fill-opacity="0.1"></path>
                                <path d="M3.5 8L9.5 6.5L19.5 4L21 8H3.5Z" fill="currentColor" fill-opacity="0.2"></path>
                                <path d="M22.1667 23.3327H5.83333C4.54467 23.3327 3.5 22.288 3.5 20.9993V10.4993C3.5 9.21068 4.54467 8.16602 5.83333 8.16602H22.1667C23.4553 8.16602 24.5 9.21069 24.5 10.4994V20.9993C24.5 22.288 23.4553 23.3327 22.1667 23.3327Z" stroke="currentColor" stroke-width="1.75"></path>
                                <path d="M19.2497 16.3327C18.9275 16.3327 18.6663 16.0715 18.6663 15.7493C18.6663 15.4272 18.9275 15.166 19.2497 15.166C19.5718 15.166 19.833 15.4272 19.833 15.7493C19.833 16.0715 19.5718 16.3327 19.2497 16.3327Z" fill="currentColor" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M21 8.16667V6.53709C21 5.00402 19.5468 3.88753 18.0654 4.28255L5.23212 7.70477C4.2107 7.97715 3.5 8.9022 3.5 9.95932V10.5" stroke="currentColor" stroke-width="1.75"></path>
                            </svg>
                        </span>
                        <span>{{ credits }}</span> credits
                    </span>
                </div>

                <!-- CTA stack -->
                <div class="cta-stack">

                    <!-- guest / logged no-pass → нужна подписка -->
                    <button
                        v-if="state === 'guest' || state === 'no-pass'"
                        class="cta-pass-primary"
                        @click="onPassPromo"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="1em" height="1em">
                            <path fill="#FFAC33" d="M34.347 16.893l-8.899-3.294-3.323-10.891c-.128-.42-.517-.708-.956-.708-.439 0-.828.288-.956.708l-3.322 10.891-8.9 3.294c-.393.146-.653.519-.653.938 0 .418.26.793.653.938l8.895 3.293 3.324 11.223c.126.424.516.715.959.715.442 0 .833-.291.959-.716l3.324-11.223 8.896-3.293c.391-.144.652-.518.652-.937 0-.418-.261-.792-.653-.938z"/>
                            <path fill="#FFCC4D" d="M14.347 27.894l-2.314-.856-.9-3.3c-.118-.436-.513-.738-.964-.738-.451 0-.846.302-.965.737l-.9 3.3-2.313.856c-.393.145-.653.52-.653.938 0 .418.26.793.653.938l2.301.853.907 3.622c.112.444.511.756.97.756.459 0 .858-.312.97-.757l.907-3.622 2.301-.853c.393-.144.653-.519.653-.937 0-.418-.26-.793-.653-.937zM10.009 6.231l-2.364-.875-.876-2.365c-.145-.393-.519-.653-.938-.653-.418 0-.792.26-.938.653l-.875 2.365-2.365.875c-.393.146-.653.52-.653.938 0 .418.26.793.653.938l2.365.875.875 2.365c.146.393.52.653.938.653.418 0 .792-.26.938-.653l.875-2.365 2.365-.875c.393-.146.653-.52.653-.938 0-.418-.26-.792-.653-.938z"/>
                        </svg>
                        <span>Unlock with Ecomzy Pass</span>
                    </button>

                    <!-- pass + хватает кредитов → списываем -->
                    <button
                        v-else-if="state === 'enough'"
                        class="cta-unlock"
                        :disabled="isLoading"
                        @click="openSpend"
                    >
                        <template v-if="isLoading">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="1em" height="1em">
                                <path fill="#FFE8B6" d="M21 18c0-2.001 3.246-3.369 5-6 2-3 2-10 2-10H8s0 7 2 10c1.754 2.631 5 3.999 5 6s-3.246 3.369-5 6c-2 3-2 10-2 10h20s0-7-2-10c-1.754-2.631-5-3.999-5-6z"/><path fill="#FFAC33" d="M18 2h-8s0 4 1 7c1.304 3.912 6 4.999 6 9s0 13 1 13 1-9 1-13 4.697-5.088 6-9c1-3 1-7 1-7h-8z"/><path fill="#3B88C3" d="M30 34c0 1.104-.896 2-2 2H8c-1.104 0-2-.896-2-2s.896-2 2-2h20c1.104 0 2 .896 2 2zm0-32c0 1.104-.896 2-2 2H8c-1.104 0-2-.896-2-2s.896-2 2-2h20c1.104 0 2 .896 2 2z"/>
                            </svg>
                            Loading…
                        </template>

                        <template v-else>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g class="lock" id="lock">
                                    <path class="shackle" d="M8 11L8 7C8 5.939 8.421 4.922 9.172 4.172C9.922 3.421 10.939 3 12 3C13.061 3 14.078 3.421 14.828 4.172C15.579 4.922 16 5.939 16 7L16 11" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M17 11H7C5.89543 11 5 11.8954 5 13V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V13C19 11.8954 18.1046 11 17 11Z" fill="currentColor" fill-opacity="0.1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12 17.5C12.8284 17.5 13.5 16.8284 13.5 16C13.5 15.1716 12.8284 14.5 12 14.5C11.1716 14.5 10.5 15.1716 10.5 16C10.5 16.8284 11.1716 17.5 12 17.5Z" fill="currentColor" fill-opacity="0.4"/>
                                </g>
                            </svg>
                            <span>Unlock for {{ costCredits }} credits</span>
                        </template>
                    </button>

                    <!-- pass + мало кредитов + можно апгрейдить → upgrade -->
                    <button
                        v-else-if="state === 'low-upgrade'"
                        class="cta-topup"
                        @click="onPassUpgrade"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="1em" height="1em">
                            <path fill="#FFCC4D" d="M2.653 35C.811 35-.001 33.662.847 32.027L16.456 1.972c.849-1.635 2.238-1.635 3.087 0l15.609 30.056c.85 1.634.037 2.972-1.805 2.972H2.653z"/><path fill="#231F20" d="M15.583 28.953c0-1.333 1.085-2.418 2.419-2.418 1.333 0 2.418 1.085 2.418 2.418 0 1.334-1.086 2.419-2.418 2.419-1.334 0-2.419-1.085-2.419-2.419zm.186-18.293c0-1.302.961-2.108 2.232-2.108 1.241 0 2.233.837 2.233 2.108v11.938c0 1.271-.992 2.108-2.233 2.108-1.271 0-2.232-.807-2.232-2.108V10.66z"/>
                        </svg>
                        <span>
                            Upgrade plan to unlock
                            <span class="cta-topup-sub">You have {{ credits }} credits — this needs {{ costCredits }}</span>
                        </span>
                    </button>

                    <!-- pass + мало кредитов + максимальный tier → ждать цикл -->
                    <div
                        v-else-if="state === 'low-max'"
                        class="cta-owned"
                    >
                        Credits refresh next cycle
                    </div>

                </div>

                <!-- low-max подсказка -->
                <div class="cta-owned-link" v-if="state === 'low-max'">
                    <span>Your Pass credits will refresh at the start of the next billing cycle.</span>
                </div>

                <!-- Trust -->
                <ul class="trust-list">
                    <li>
                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="1em" height="1em">
                                <path fill="#CCD6DD" d="M33 3c-7-3-15-3-15-3S10 0 3 3C0 18 3 31 18 36c15-5 18-18 15-33z"/>
                                <path fill="#55ACEE" d="M18 33.884C6.412 29.729 1.961 19.831 4.76 4.444 11.063 2.029 17.928 2 18 2c.071 0 6.958.04 13.24 2.444 2.799 15.387-1.652 25.285-13.24 29.44z"/>
                                <path fill="#269" d="M31.24 4.444C24.958 2.04 18.071 2 18 2v31.884c11.588-4.155 16.039-14.053 13.24-29.44z"/>
                            </svg>
                        </span>
                        30-day money-back guarantee on your Pass
                    </li>
                    <li>
                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="1em" height="1em">
                                <path fill="#AAB8C2" d="M18 3C12.477 3 8 7.477 8 13v10h4V13c0-3.313 2.686-6 6-6s6 2.687 6 6v10h4V13c0-5.523-4.477-10-10-10z"/>
                                <path fill="#FFAC33" d="M31 32c0 2.209-1.791 4-4 4H9c-2.209 0-4-1.791-4-4V20c0-2.209 1.791-4 4-4h18c2.209 0 4 1.791 4 4v12z"/>
                            </svg>
                        </span>
                        Secure access via your account
                    </li>
                    <li>
                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="1em" height="1em">
                                <path fill="#FFAC33" d="M32.938 15.651C32.792 15.26 32.418 15 32 15H19.925L26.89 1.458c.219-.426.106-.947-.271-1.243C26.437.071 26.218 0 26 0c-.233 0-.466.082-.653.243L18 6.588 3.347 19.243c-.316.273-.43.714-.284 1.105S3.582 21 4 21h12.075L9.11 34.542c-.219.426-.106.947.271 1.243.182.144.401.215.619.215.233 0 .466-.082.653-.243L18 29.412l14.653-12.655c.317-.273.43-.714.285-1.106z"/>
                            </svg>
                        </span>
                        Instant unlock — added to your library
                    </li>
                </ul>

                <hr class="divider">

                <div class="footer-stat" v-if="buyBox.social_proof">
                    <span class="count">{{ buyBox.social_proof.count }}</span>
                    <span class="label" v-html="buyBox.social_proof.label"></span>
                </div>
            </template>
        </div>

        <!-- SUBSCRIPTION GATE (guest) -->
        <teleport to="body">
            <div class="sub-gate" :class="{ show: state === 'guest' }">
                <div class="sub-gate-card">

                    <div class="sub-gate-hero">
                        <div class="sub-gate-hero-content">
                            <div class="sub-gate-product-mini">
                                <div class="sub-gate-product-mini-icon" v-html="productEmoji"></div>
                                <span class="sub-gate-product-mini-name">{{ product.name }}</span>
                            </div>
                            <div class="sub-gate-lock">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                     stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2"/>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                </svg>
                            </div>
                            <h2 class="sub-gate-title">
                                This product is <em>Pass only.</em>
                            </h2>
                            <p class="sub-gate-sub">
                                Start an Ecomzy Pass to unlock this plan and the rest of the Pass-only library with credits.
                            </p>
                        </div>
                    </div>

                    <div class="sub-gate-body">
                        <div class="sub-gate-perks">
                            <div class="sub-gate-perks-title">What you get with Ecomzy Pass</div>
                            <div class="sub-gate-perk">
                                <span class="sub-gate-perk-check">✓</span>
                                <span>Monthly credits to unlock any Pass-only product (1 credit = $1)</span>
                            </div>
                            <div class="sub-gate-perk">
                                <span class="sub-gate-perk-check">✓</span>
                                <span>Full access to every Pass-exclusive planner, toolkit, and template</span>
                            </div>
                            <div class="sub-gate-perk">
                                <span class="sub-gate-perk-check">✓</span>
                                <span>Cancel anytime · 30-day money-back guarantee</span>
                            </div>
                        </div>

                        <div class="sub-gate-actions">
                            <button class="sub-gate-btn sub-gate-btn-primary" @click="onGateCta('see_plans')">
                                See plans
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                     stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
                            </button>
                            <div class="sub-gate-divider">or</div>
                            <button class="sub-gate-btn sub-gate-btn-secondary" @click="onGateCta('sign_in')">
                                I already have an account — Sign in
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </teleport>

        <!-- SPEND CREDITS CONFIRM -->
        <teleport to="body">
            <div class="spend-modal" :class="{ show: showSpend }">
                <div class="spend-modal-card">
                    <div class="spend-modal-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                             stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2"/>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4M12 16v2"/>
                        </svg>
                    </div>
                    <div class="spend-modal-title">Unlock with credits?</div>
                    <div class="spend-modal-desc">
                        <strong>{{ costCredits }} credits</strong> will be deducted from your Pass balance and this
                        product will be added to your library.</div>
                    <div class="spend-modal-summary">
                        <div class="spend-modal-summary-row">
                            <span class="spend-modal-summary-label">Cost</span>
                            <span class="spend-modal-summary-val"><span class="credit-coin">
                                <svg width="18" height="18" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.5 8L9.5 6.5L19.5 4L21 8L24 9V22.5L4.5 23L3.5 19.5V8Z" fill="currentColor" fill-opacity="0.1"></path>
                                    <path d="M3.5 8L9.5 6.5L19.5 4L21 8H3.5Z" fill="currentColor" fill-opacity="0.2"></path>
                                    <path d="M22.1667 23.3327H5.83333C4.54467 23.3327 3.5 22.288 3.5 20.9993V10.4993C3.5 9.21068 4.54467 8.16602 5.83333 8.16602H22.1667C23.4553 8.16602 24.5 9.21069 24.5 10.4994V20.9993C24.5 22.288 23.4553 23.3327 22.1667 23.3327Z" stroke="currentColor" stroke-width="1.75"></path>
                                    <path d="M19.2497 16.3327C18.9275 16.3327 18.6663 16.0715 18.6663 15.7493C18.6663 15.4272 18.9275 15.166 19.2497 15.166C19.5718 15.166 19.833 15.4272 19.833 15.7493C19.833 16.0715 19.5718 16.3327 19.2497 16.3327Z" fill="currentColor" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M21 8.16667V6.53709C21 5.00402 19.5468 3.88753 18.0654 4.28255L5.23212 7.70477C4.2107 7.97715 3.5 8.9022 3.5 9.95932V10.5" stroke="currentColor" stroke-width="1.75"></path>
                                </svg>
                            </span> {{ costCredits }}</span>
                        </div>
                        <div class="spend-modal-summary-row right">
                            <span class="spend-modal-summary-label">Balance after</span>
                            <span class="spend-modal-summary-val">
                                <span class="credit-coin">
                                    <svg width="18" height="18" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.5 8L9.5 6.5L19.5 4L21 8L24 9V22.5L4.5 23L3.5 19.5V8Z" fill="currentColor" fill-opacity="0.1"></path>
                                        <path d="M3.5 8L9.5 6.5L19.5 4L21 8H3.5Z" fill="currentColor" fill-opacity="0.2"></path>
                                        <path d="M22.1667 23.3327H5.83333C4.54467 23.3327 3.5 22.288 3.5 20.9993V10.4993C3.5 9.21068 4.54467 8.16602 5.83333 8.16602H22.1667C23.4553 8.16602 24.5 9.21069 24.5 10.4994V20.9993C24.5 22.288 23.4553 23.3327 22.1667 23.3327Z" stroke="currentColor" stroke-width="1.75"></path>
                                        <path d="M19.2497 16.3327C18.9275 16.3327 18.6663 16.0715 18.6663 15.7493C18.6663 15.4272 18.9275 15.166 19.2497 15.166C19.5718 15.166 19.833 15.4272 19.833 15.7493C19.833 16.0715 19.5718 16.3327 19.2497 16.3327Z" fill="currentColor" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M21 8.16667V6.53709C21 5.00402 19.5468 3.88753 18.0654 4.28255L5.23212 7.70477C4.2107 7.97715 3.5 8.9022 3.5 9.95932V10.5" stroke="currentColor" stroke-width="1.75"></path>
                                    </svg>
                                </span> {{ balanceAfter }}
                            </span>
                        </div>
                    </div>
                    <div class="spend-modal-actions">
                        <button class="spend-modal-cancel" @click="showSpend = false">Cancel</button>
                        <button class="spend-modal-confirm" :disabled="isLoading" @click="confirmSpend">Confirm unlock</button>
                    </div>
                </div>
            </div>
        </teleport>
    </div>
</template>

<script>
import { track, trackEcommerce, gtmItem, productParams, GTM_EVENTS } from '../../js/utils/gtm';

export default {
    name: 'PassBuyBox',

    props: {
        product : { type: Object, required: true },
        buyBox  : { type: Object, default: () => ({}) },
    },

    data() {
        const pd = window.productData || {};

        return {
            isAuth     : !! pd.is_auth,
            isOwned    : !! pd.is_owned,
            hasPass    : !! pd.has_pass,
            isMax      : !! pd.is_max,
            credits    : Number( pd.credits ?? 0 ),
            costCredits: Number( pd.cost_credits ?? Math.round( ( this.product.sale_price || 0 ) / 100 ) ),

            isLoading : false,
            showSpend : false,
            baseURL   : window.baseURL || '',
            accURL    : window.accURL || '',
            ownedUrl  : ( window.productData?.toolkit_url ) || ( window.accURL || '' ),
        };
    },

    computed: {

        state() {
            if( ! this.isAuth )
                return 'guest';

            if( this.isOwned )
                return 'owned';

            if( ! this.hasPass )
                return 'no-pass';

            if( this.credits >= this.costCredits )
                return 'enough';

            if( this.isMax )
                return 'low-max';

            return 'low-upgrade';
        },

        isLow() {
            return this.state === 'low-upgrade' || this.state === 'low-max';
        },

        hasDiscount() {
            return this.product.price > 0 && this.product.sale_price < this.product.price;
        },

        savePercent() {
            if( ! this.hasDiscount )
                return 0;

            return Math.round( ( 1 - this.product.sale_price / this.product.price ) * 100 );
        },

        balanceAfter() {
            return Math.max( 0, this.credits - this.costCredits );
        },

        productEmoji() {
            console.log(this.product);
            return this.product.emoji || '🛍️';
        },

        priceMeta() {
            const map = {
                'guest'       : 'Pass only · Instant access · Sign in or start a Pass to unlock',
                'no-pass'     : 'Pass only · Instant access · Available with any Ecomzy Pass',
                'enough'      : `Pass only · Instant unlock · ${ this.costCredits } credits will be deducted`,
                'low-upgrade' : 'Pass only · Upgrade your Pass to get enough credits for this',
                'low-max'     : 'Pass only · Your credits will refresh next billing cycle',
                'owned'       : 'You unlocked this product · Open it from your library anytime',
            };

            return map[ this.state ] || '';
        },
    },

    mounted() {
        // guest -> блюрим страницу под gate
        if( this.state === 'guest' )
            document.body.classList.add('is-gated');

        this.trackProductView();
    },

    beforeUnmount() {
        document.body.classList.remove('is-gated');
    },

    methods: {

        formatMoney( cents ) {
            if( ! cents && cents !== 0 )
                return '';

            const d = cents / 100;
            return '$' + ( Number.isInteger( d ) ? d : d.toFixed( 2 ) );
        },

        // ③ PP: view_item + product_cta_viewed (+ pass_gate_viewed для guest).
        trackProductView() {

            const priceUsd = +( ( this.product.sale_price || 0 ) / 100 ).toFixed( 2 );

            const cardState = {
                'guest'       : 'guest',
                'no-pass'     : 'logged_no_pass',
                'enough'      : 'pass_enough',
                'low-upgrade' : 'pass_low',
                'low-max'     : 'pass_low',
                'owned'       : 'owned',
            }[ this.state ] || this.state;

            // F-19: item_category - дискриминатор 'product'; pass_only живёт в product_type (F-04).
            trackEcommerce( GTM_EVENTS.VIEW_ITEM, {
                currency : 'USD',
                value    : priceUsd,
                items    : [ gtmItem( {
                    id       : this.product.slug,
                    name     : this.product.name,
                    category : 'product',
                    price    : priceUsd,
                } ) ],
            }, productParams( {   // F-04 + F-03: product_id строкой
                id   : this.product.id,
                type : 'pass_only',
            } ) );

            track( GTM_EVENTS.PRODUCT_CTA_VIEWED, productParams( {
                id         : this.product.id,
                type       : 'pass_only',
                card_state : cardState,
            } ) );

            // PGATE - главная friction-метрика гостевого gate.
            if( this.state === 'guest' )
                track( GTM_EVENTS.PASS_GATE_VIEWED, productParams( { id: this.product.id } ) );
        },

        goPricing( source ) {
            // source проставляем в ?source= - в pricing.volt query имеет приоритет
            // над referrer-эвристикой (нужно чтобы 'gate' не терялся: гейт на product page).
            const q = source ? ( '?source=' + encodeURIComponent( source ) ) : '';
            window.location.href = this.baseURL + '/pricing' + q;
        },

        goLogin() {
            window.location.href = this.accURL;
        },

        // CTA "Unlock with Ecomzy Pass" (guest / no-pass)
        onPassPromo() {
            track( GTM_EVENTS.PASS_PROMO_CLICKED, productParams( { id: this.product.id, source: 'product_page' } ) );
            this.goPricing( 'product' );
        },

        // CTA "Upgrade plan" (low-upgrade)
        onPassUpgrade() {
            track( GTM_EVENTS.PASS_UPGRADE_CLICKED, productParams( { id: this.product.id, reason: 'insufficient_credits' } ) );
            // Redirect на manage subscription
            window.open(this.accURL + '/subscription', '_blank');
        },

        // Gate "See plans" / "Sign in"
        onGateCta( action ) {
            track( GTM_EVENTS.PASS_GATE_CTA_CLICKED, productParams( { id: this.product.id, action } ) );
            action === 'sign_in' ? this.goLogin() : this.goPricing( 'gate' );
        },

        openSpend() {
            if( this.isLoading )
                return;

            // credits_unlock_started шлётся на /checkout (Checkout.vue init, isFullyCovered),
            // куда сходятся все кредитные разблокировки - здесь не дублируем.
            this.showSpend = true;
        },

        confirmSpend() {
            if( this.isLoading )
                return;

            this.isLoading = true;

            // списание кредитов идёт на checkout (механизм уже есть)
            sessionStorage.setItem( 'checkout_product_id', String( this.product.id ) );
            sessionStorage.setItem( 'checkout_product_slug', this.product.slug );
            window.location.href = this.baseURL + '/checkout/' + this.product.slug;
        },
    },
};
</script>